// Definición de defaults

export const defaultTipoMovimiento: TipoMovimientoProps = {
    idTipoMovimiento:   0,
    descripcion:        '',
    activo:             false
};

// Creación de interfaces

export interface TipoMovimientoProps   {
    idTipoMovimiento:   number;
    descripcion:        string;
    activo:             boolean;
}